import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Calendar } from 'lucide-react';
import { resolveImageUrl, formatDate } from '../lib/api';
import { useLanguage } from '../i18n/LanguageContext';

export const BlogCard = ({ post, index = 0 }) => {
  const { t, lang } = useLanguage();
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-[#8B2C3A] hover:shadow-xl transition-all duration-300 animate-in fade-in slide-in-from-bottom-4"
      style={{ animationDelay: `${index * 60}ms`, animationFillMode: 'both' }}
    >
      <div className="relative aspect-[3/2] overflow-hidden bg-gray-100">
        {post.cover_image && (
          <img
            src={resolveImageUrl(post.cover_image)}
            alt={post.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        )}
        <span className="absolute top-3 left-3 bg-[#8B2C3A] text-white text-xs font-semibold px-3 py-1 rounded-full">
          {post.category}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <div className="flex items-center gap-4 text-xs text-gray-500 mb-3">
          <span className="inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" />{formatDate(post.created_at, lang)}</span>
          <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{post.read_time} {t('blog.minRead')}</span>
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#8B2C3A] transition-colors line-clamp-2">{post.title}</h3>
        <p className="text-sm text-gray-600 line-clamp-3 flex-1">{post.excerpt}</p>
        <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#8B2C3A]">
          {t('blog.readMore')}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  );
};
